/**
 * Launcher
 *
 * An asyncronous script-loader for TNT using headjs.
 *
 * [ Example implementation using manifest ]
 *
 * <head>
 *    <script src="/apps/common/latest/launcher.min.js"
 *            data-manifest="/apps/nbt/manifest.json"
 *            data-set="set1 set2"
 *            data-rivision="1.0.1"></script>
 * </head>
 *
 * [ Example implementation using files ]
 *
 * <head>
 *    <script src="/apps/common/latest/launcher.min.js"
 *            data-files="/apps/common/latest/common-angular1-3.js,/apps/nbt/obt.app.js"
 *            data-rivision="1.0.1"></script>
 * </head>
 *
 *
 * [ Attributes explained ]
 *
 * data-manifest: Used to point to a manifest.json file in your project. This manifest file
 *                should contain "sets" of js files that can be loaded with the launcher.
 *                { "set1": [ "file1.js", "file2.js"], "set2": ["file3.js"] }
 *
 * data-files: a comma/space separated list of js files to load asynchronously. This attribute
 *             can be safely combined with data-manifest
 *
 * data-set: Space-separated list of "sets" of dependencies you want to load from the manifest.
 *           Note, it's possible to load multiple launchers on the page - duplicate dependencies
 *           in these sets will only be loaded once.
 *
 * data-revision: You can add an incremented version/revision/build/timestamp using this attribute.
 *                This string will be appended to every (non-http) asset that needs to be loaded
 *                to provide you with client-side caching control.
 *
 *
 * [ Bootstrapping your App ]
 *
 * You can use the Launcher.ready method to detect if all scripts are loaded and bootstrap
 * your angular application, for example:
 *
 * Launcher.ready(function(){
 *     angular.bootstrap(angular.element('obt-app')[0], ['obtApp']);
 * });
 *
 *
 * [ Extras ]
 *
 * Additionally, because headjs is used, you also get these features:
 *
 * - HTML5 shim
 * - <html> browser classes (lt-ie9, no-mobile, chrome, etc)
 * - <html> compatibility classes (touch, borderradius, fontfacve, etc)
 * - <html> responsive classes (gt-768, lt-1440, etc)
 * - Plus several javascript methods to use these features programmatically, see http://headjs.com/site/api/v1.00.html
 *
 * Questions: Filidor Wiese <fili@fili.nl>
 */

// Only execute if not already loaded
if (typeof window.Launcher === 'undefined') {

  // This is a minified version of the src/head.js file, which is an edited version from the bower module
  !function (e, t) {
    "use strict";
    function n(e) {
      d[d.length] = e
    }

    function r(e) {
      var t = new RegExp(" ?\\b" + e + "\\b");
      l.className = l.className.replace(t, "")
    }

    function o(e, t) {
      for (var n = 0, r = e.length; r > n; n++)t.call(e, e[n], n)
    }

    function a() {
      l.className = l.className.replace(/ (w-|eq-|gt-|gte-|lt-|lte-|portrait|no-portrait|landscape|no-landscape)\d+/g, "");
      var t = e.innerWidth || l.clientWidth, r = e.outerWidth || e.screen.width;
      m.screen.innerWidth = t, m.screen.outerWidth = r, n("w-" + t), o(f.screens, function (e) {
        t > e ? (f.screensCss.gt && n("gt-" + e), f.screensCss.gte && n("gte-" + e)) : e > t ? (f.screensCss.lt && n("lt-" + e), f.screensCss.lte && n("lte-" + e)) : t === e && (f.screensCss.lte && n("lte-" + e), f.screensCss.eq && n("e-q" + e), f.screensCss.gte && n("gte-" + e))
      });
      var a = e.innerHeight || l.clientHeight, s = e.outerHeight || e.screen.height;
      m.screen.innerHeight = a, m.screen.outerHeight = s, m.feature("portrait", a > t), m.feature("landscape", t > a)
    }

    function s() {
      e.clearTimeout(E), E = e.setTimeout(a, 50)
    }

    var i = e.document, c = e.navigator, u = e.location, l = i.documentElement, d = [], f = {
      screens: [240, 320, 480, 640, 768, 800, 1024, 1280, 1440, 1680, 1920],
      screensCss: { gt: !0, gte: !1, lt: !0, lte: !1, eq: !1 },
      browsers: [{ ie: { min: 6, max: 11 } }],
      browserCss: { gt: !0, gte: !1, lt: !0, lte: !1, eq: !0 },
      html5: !0,
      page: "-page",
      section: "-section",
      head: "head"
    };
    if (e.head_conf)for (var h in e.head_conf)e.head_conf[h] !== t && (f[h] = e.head_conf[h]);
    var m = e[f.head] = function () {
      m.ready.apply(null, arguments)
    };
    m.feature = function (e, t, o) {
      return e ? ("[object Function]" === Object.prototype.toString.call(t) && (t = t.call()), n((t ? "" : "no-") + e), m[e] = !!t, o || (r("no-" + e), r(e), m.feature()), m) : (l.className += " " + d.join(" "), d = [], m)
    }, m.feature("js", !0);
    var p = c.userAgent.toLowerCase(), g = /mobile|android|kindle|silk|midp|phone|(windows .+arm|touch)/.test(p);
    m.feature("mobile", g, !0), m.feature("desktop", !g, !0), p = /(chrome|firefox)[ \/]([\w.]+)/.exec(p) || /(iphone|ipad|ipod)(?:.*version)?[ \/]([\w.]+)/.exec(p) || /(android)(?:.*version)?[ \/]([\w.]+)/.exec(p) || /(webkit|opera)(?:.*version)?[ \/]([\w.]+)/.exec(p) || /(msie) ([\w.]+)/.exec(p) || /(trident).+rv:(\w.)+/.exec(p) || [];
    var v = p[1], b = parseFloat(p[2]);
    switch (v) {
      case"msie":
      case"trident":
        v = "ie", b = i.documentMode || b;
        break;
      case"firefox":
        v = "ff";
        break;
      case"ipod":
      case"ipad":
      case"iphone":
        v = "ios";
        break;
      case"webkit":
        v = "safari"
    }
    m.browser = { name: v, version: b }, m.browser[v] = !0;
    for (var y = 0, w = f.browsers.length; w > y; y++)for (var x in f.browsers[y])if (v === x) {
      n(x);
      for (var C = f.browsers[y][x].min, T = f.browsers[y][x].max, k = C; T >= k; k++)b > k ? (f.browserCss.gt && n("gt-" + x + k), f.browserCss.gte && n("gte-" + x + k)) : k > b ? (f.browserCss.lt && n("lt-" + x + k), f.browserCss.lte && n("lte-" + x + k)) : b === k && (f.browserCss.lte && n("lte-" + x + k), f.browserCss.eq && n("eq-" + x + k), f.browserCss.gte && n("gte-" + x + k))
    } else n("no-" + x);
    n(v), n(v + parseInt(b, 10)), f.html5 && "ie" === v && 9 > b && o("abbr|article|aside|audio|canvas|details|figcaption|figure|footer|header|hgroup|main|mark|meter|nav|output|progress|section|summary|time|video".split("|"), function (e) {
      i.createElement(e)
    }), o(u.pathname.split("/"), function (e, r) {
      if (this.length > 2 && this[r + 1] !== t)r && n(this.slice(r, r + 1).join("-").toLowerCase() + f.section); else {
        var o = e || "index", a = o.indexOf(".");
        a > 0 && (o = o.substring(0, a)), l.id = o.toLowerCase() + f.page, r || n("root" + f.section)
      }
    }), m.screen = { height: e.screen.height, width: e.screen.width }, a();
    var E = 0;
    e.addEventListener ? e.addEventListener("resize", s, !1) : e.attachEvent("onresize", s)
  }(window), function (e, t) {
    "use strict";
    function n(e) {
      for (var n in e)if (s[e[n]] !== t)return !0;
      return !1
    }

    function r(e) {
      var t = e.charAt(0).toUpperCase() + e.substr(1), r = (e + " " + c.join(t + " ") + t).split(" ");
      return !!n(r)
    }

    var o = e.document, a = o.createElement("i"), s = a.style, i = " -o- -moz- -ms- -webkit- -khtml- ".split(" "), c = "Webkit Moz O ms Khtml".split(" "), u = e.head_conf && e.head_conf.head || "head", l = e[u], d = {
      gradient: function () {
        var e = "background-image:", t = "gradient(linear,left top,right bottom,from(#9f9),to(#fff));", n = "linear-gradient(left top,#eee,#fff);";
        return s.cssText = (e + i.join(t + e) + i.join(n + e)).slice(0, -e.length), !!s.backgroundImage
      }, rgba: function () {
        return s.cssText = "background-color:rgba(0,0,0,0.5)", !!s.backgroundColor
      }, opacity: function () {
        return "" === a.style.opacity
      }, textshadow: function () {
        return "" === s.textShadow
      }, multiplebgs: function () {
        s.cssText = "background:url(https://),url(https://),red url(https://)";
        var e = (s.background || "").match(/url/g);
        return "[object Array]" === Object.prototype.toString.call(e) && 3 === e.length
      }, boxshadow: function () {
        return r("boxShadow")
      }, borderimage: function () {
        return r("borderImage")
      }, borderradius: function () {
        return r("borderRadius")
      }, cssreflections: function () {
        return r("boxReflect")
      }, csstransforms: function () {
        return r("transform")
      }, csstransitions: function () {
        return r("transition")
      }, touch: function () {
        return "ontouchstart" in e
      }, retina: function () {
        return e.devicePixelRatio > 1
      }, fontface: function () {
        var e = l.browser.name, t = l.browser.version;
        switch (e) {
          case"ie":
            return t >= 9;
          case"chrome":
            return t >= 13;
          case"ff":
            return t >= 6;
          case"ios":
            return t >= 5;
          case"android":
            return !1;
          case"webkit":
            return t >= 5.1;
          case"opera":
            return t >= 10;
          default:
            return !1
        }
      }
    };
    for (var f in d)d[f] && l.feature(f, d[f].call(), !0);
    l.feature()
  }(window), function (e, t) {
    "use strict";
    function n() {
    }

    function r(e, t) {
      if (e) {
        "object" == typeof e && (e = [].slice.call(e));
        for (var n = 0, r = e.length; r > n; n++)t.call(e, e[n], n)
      }
    }

    function o(e, n) {
      var r = Object.prototype.toString.call(n).slice(8, -1);
      return n !== t && null !== n && r === e
    }

    function a(e) {
      return o("Function", e)
    }

    function s(e) {
      return o("Array", e)
    }

    function i(e) {
      var t = e.split("/"), n = t[t.length - 1], r = n.indexOf("?");
      return -1 !== r ? n.substring(0, r) : n
    }

    function c(e) {
      e = e || n, e._done || (e(), e._done = 1)
    }

    function u(e, t, r, o) {
      var a = "object" == typeof e ? e : {
        test: e,
        success: t ? s(t) ? t : [t] : !1,
        failure: r ? s(r) ? r : [r] : !1,
        callback: o || n
      }, i = !!a.test;
      return i && a.success ? (a.success.push(a.callback), _.load.apply(null, a.success)) : !i && a.failure ? (a.failure.push(a.callback), _.load.apply(null, a.failure)) : o(), _
    }

    function l(e) {
      var t = {};
      if ("object" == typeof e)for (var n in e)e[n] && (t = { name: n, url: e[n] }); else t = { name: i(e), url: e };
      var r = j[t.name];
      return r && r.url === t.url ? r : (j[t.name] = t, t)
    }

    function d(e) {
      e = e || j;
      for (var t in e)if (e.hasOwnProperty(t) && e[t].state !== N)return !1;
      return !0
    }

    function f(e) {
      e.state = q, r(e.onpreload, function (e) {
        e.call()
      })
    }

    function h(e) {
      e.state === t && (e.state = O, e.onpreload = [], b({ url: e.url, type: "cache" }, function () {
        f(e)
      }))
    }

    function m() {
      var e = arguments, t = e[e.length - 1], n = [].slice.call(e, 1), o = n[0];
      return a(t) || (t = null), s(e[0]) ? (e[0].push(t), _.load.apply(null, e[0]), _) : (o ? (r(n, function (e) {
        !a(e) && e && h(l(e))
      }), g(l(e[0]), a(o) ? o : function () {
        _.load.apply(null, n)
      })) : g(l(e[0])), _)
    }

    function p() {
      var e = arguments, t = e[e.length - 1], n = {};
      return a(t) || (t = null), s(e[0]) ? (e[0].push(t), _.load.apply(null, e[0]), _) : (r(e, function (e) {
        e !== t && (e = l(e), n[e.name] = e)
      }), r(e, function (e) {
        e !== t && (e = l(e), g(e, function () {
          d(n) && c(t)
        }))
      }), _)
    }

    function g(e, t) {
      return t = t || n, e.state === N ? void t() : e.state === M ? void _.ready(e.name, t) : e.state === O ? void e.onpreload.push(function () {
        g(e, t)
      }) : (e.state = M, void b(e, function () {
        e.state = N, t(), r(L[e.name], function (e) {
          c(e)
        }), T && d() && r(L.ALL, function (e) {
          c(e)
        })
      }))
    }

    function v(e) {
      e = e || "";
      var t = e.split("?")[0].split(".");
      return t[t.length - 1].toLowerCase()
    }

    function b(r, o) {
      function a(t) {
        t = t || e.event, c.onload = c.onreadystatechange = c.onerror = null, o()
      }

      function s(t) {
        t = t || e.event, ("load" === t.type || /loaded|complete/.test(c.readyState) && (!k.documentMode || k.documentMode < 9)) && (e.clearTimeout(r.errorTimeout), e.clearTimeout(r.cssTimeout), c.onload = c.onreadystatechange = c.onerror = null, o())
      }

      function i() {
        if (r.state !== N && r.cssRetries <= 20) {
          for (var t = 0, n = k.styleSheets.length; n > t; t++)if (k.styleSheets[t].href === c.href)return void s({ type: "load" });
          r.cssRetries++, r.cssTimeout = e.setTimeout(i, 250)
        }
      }

      o = o || n;
      var c, u = v(r.url);
      "css" === u ? (c = k.createElement("link"), c.type = "text/" + (r.type || "css"), c.rel = "stylesheet", c.href = r.url, r.cssRetries = 0, r.cssTimeout = e.setTimeout(i, 500)) : (c = k.createElement("script"), c.type = "text/" + (r.type || "javascript"), c.src = r.url), c.onload = c.onreadystatechange = s, c.onerror = a, c.async = !1, c.defer = !1, r.errorTimeout = t;
      var l = k.head || k.getElementsByTagName("head")[0];
      l.insertBefore(c, l.lastChild)
    }

    function y() {
      for (var e = k.getElementsByTagName("script"), t = 0, n = e.length; n > t; t++) {
        var r = e[t].getAttribute("data-headjs-load");
        if (r)return void _.load(r)
      }
    }

    function w(e, t) {
      if (e === k)return T ? c(t) : E.push(t), _;
      if (a(e) && (t = e, e = "ALL"), s(e)) {
        var n = {};
        return r(e, function (e) {
          n[e] = j[e], _.ready(e, function () {
            d(n) && c(t)
          })
        }), _
      }
      if ("string" != typeof e || !a(t))return _;
      var o = j[e];
      if (o && o.state === N || "ALL" === e && d() && T)return c(t), _;
      var i = L[e];
      return i ? i.push(t) : i = L[e] = [t], _
    }

    function x() {
      return k.body ? void(T || (T = !0, y(), r(E, function (e) {
        c(e)
      }))) : (e.clearTimeout(_.readyTimeout), void(_.readyTimeout = e.setTimeout(x, 50)))
    }

    function C() {
      k.addEventListener ? (k.removeEventListener("DOMContentLoaded", C, !1), x()) : "complete" === k.readyState && (k.detachEvent("onreadystatechange", C), x())
    }

    var T, k = e.document, E = [], L = {}, j = {}, S = "async" in k.createElement("script") || "MozAppearance" in k.documentElement.style || e.opera, A = e.head_conf && e.head_conf.head || "head", _ = e[A] = e[A] || function () {
        _.ready.apply(null, arguments)
      }, O = 1, q = 2, M = 3, N = 4;
    if ("complete" === k.readyState)x(); else if (k.addEventListener)k.addEventListener("DOMContentLoaded", C, !1), e.addEventListener("load", x, !1); else {
      k.attachEvent("onreadystatechange", C), e.attachEvent("onload", x);
      var R = !1;
      try {
        R = !e.frameElement && k.documentElement
      } catch (W) {
      }
      R && R.doScroll && !function z() {
        if (!T) {
          try {
            R.doScroll("left")
          } catch (t) {
            return e.clearTimeout(_.readyTimeout), void(_.readyTimeout = e.setTimeout(z, 50))
          }
          x()
        }
      }()
    }
    _.load = _.js = S ? p : m, _.test = u, _.ready = w, _.ready(k, function () {
      d() && r(L.ALL, function (e) {
        c(e)
      }), _.feature && _.feature("domloaded", !0)
    })
  }(window);

  window.Launcher = {
    debug: true,

    launchers: [],

    assets: [],

    readyQueue: [],

    allLoaded: false,

    init: function () {
      // Find Launcher script-tags
      // Be able to find:
      // - launcher.js
      // - launcher.min.js
      // - launcher.min-1234556789012.js
      // - launcher-1234556789012.js
      Launcher.launchers = Launcher.getLaunchers(/launcher(\.min|)(-[0-9]{13}|).js(\?.*)?$/);
      if (!Launcher.launchers) {
        throw 'Launcher: having trouble finding my own script tag';
      }

      // Load sets
      Launcher.loadSets(Launcher.launchers);
    },

    /**
     * Find launcher script tags in the head of the page and retrieve the manifest and set definitions
     */
    getLaunchers: function (regex) {
      var set, manifest, revision;
      var scripts = document.getElementsByTagName('script');
      var foundLaunchers = [];
      for (var i = 0; i < scripts.length; i++) {
        if (scripts[i].src.match(regex)) {
          sets = Launcher.getAttr(scripts[i], 'data-set');
          manifest = Launcher.getAttr(scripts[i], 'data-manifest');
          files = Launcher.getAttr(scripts[i], 'data-files');
          revision = Launcher.getAttr(scripts[i], 'data-revision');

          var newLauncher = {
            revision: revision,
            assets: []
          };

          if (files) {
            files = files.replace(/,/g, ' ').split(' ');
            newLauncher.assets = files;
            Launcher.log('found ' + files.length + ' statically defined files');
          }

          if (manifest && sets) {
            sets = sets.replace(/,/g, ' ').split(' ');
            newLauncher['manifest'] = manifest;
            newLauncher['set'] = sets;
            Launcher.log('found manifest ' + manifest + ' with set "' + sets + '"');
          }


          foundLaunchers.push(newLauncher);
        }
      }
      return foundLaunchers;
    },

    /**
     * Load json manifest files and retrieve the assets of the specified sets (using data-set)
     */
    loadSets: function (launchers) {
      var manifest, url, set, asset;
      var setsLoaded = 0;
      for (var i = 0; i < launchers.length; i++) {
        manifest = launchers[i].manifest;
        if (manifest) {
          url = (launchers[i].revision ? manifest + (launchers[i].manifest.indexOf('?') < 0 ? '?' : '&') + launchers[i].revision : manifest);

          Launcher.loadAjaxJSON(i, url, function (launcherId, data) {
            if (data) {
              for (var j = 0; j < launchers[launcherId].set.length; j++) {
                set = data[launchers[launcherId].set[j]];
                if (set) {
                  for (var k = 0; k < set.length; k++) {
                    asset = set[k];
                    if (asset) {
                      Launcher.launchers[launcherId].assets.push(asset);
                    }
                  }
                } else {
                  if (typeof set !== 'undefined') {
                    Launcher.log('data-set ' + set + ' not found in manifest ' + manifest, 'warn');
                  }
                }
              }
            }

            setsLoaded++;
            if (setsLoaded === launchers.length) {
              Launcher.loadAssets();
            }
          });
        } else {
          setsLoaded++;
          if (setsLoaded === launchers.length) {
            Launcher.loadAssets();
          }
        }
      }
    },

    /**
     * Load the assets found earlier, maintain sequence and prevent doubles
     */
    loadAssets: function () {
      var url, revision, asset, label, lastAssetToLoad;
      var labelCounter = 0;
      var assetsToLoad = [];
      for (var l = 0; l < Launcher.launchers.length; l++) {
        for (var m = 0; m < Launcher.launchers[l].assets.length; m++) {
          labelCounter++;
          url = Launcher.launchers[l].assets[m];
          revision = Launcher.launchers[l].revision;
          label = 'label' + labelCounter;
          asset = {};

          // Check, just to make sure that no css files are added to be loaded
          if (url.match(/\.css(\?|$)/)) {
            Launcher.log('Please don\'t include css files, loading these async doesn\'t work well on some legacy browsers');
            continue;
          }

          // Add unique assets to an array of assets to load and append the revision on non-http assets
          if (!Launcher.inArray(url, assetsToLoad)) {
            if (!revision || url.substr(0, 5) === 'http:' || url.substr(0, 6) === 'https:' || url.indexOf('?') > -1) {
              asset[label] = url;
            } else {
              asset[label] = url + '?' + revision;
            }
            assetsToLoad.push(asset);

            // Keep track of last asset to load, used in when determining ready
            lastAssetToLoad = label;
          }
        }
      }

      if (assetsToLoad.length) {
        Launcher.log(assetsToLoad.length + ' assets found, loading...');

        // Pass it over to HeadJS for parallel downloading and sequential execution
        var loadStartTime = +new Date();
        head.load(assetsToLoad);

        // Listen on ready event of last asset, when loaded, process ready queue
        head.ready(lastAssetToLoad, function () {
          Launcher.log('done loading in ' + (+new Date() - loadStartTime) / 1000 + 's');
          Launcher.processReadyQueue();
          Launcher.allLoaded = true;
        });
      }
    },

    /**
     * When called, either call the callback immediatly when all assets have been loaded
     * or push it to a queue to be called as soon as launcher is ready
     */
    ready: function (cb) {
      if (Launcher.isFunction(cb)) {
        if (Launcher.allLoaded) {
          cb();
        } else {
          Launcher.readyQueue.push(cb);
        }
      }
    },

    /**
     * Cross-browser document ready detection
     * http://www.dustindiaz.com/smallest-domready-ever
     */
    domReady: function (f) {
      /in/.test(document.readyState) ? setTimeout('Launcher.domReady(' + f + ')', 9) : f()
    },

    /**
     * After all assets have been loaded, this will fire all registered ready callbacks in queue
     */
    processReadyQueue: function () {
      if (!Launcher.allLoaded) {
        for (var i = 0; i < Launcher.readyQueue.length; i++) {
          Launcher.readyQueue[i]();
        }
        Launcher.log('ready, ' + Launcher.readyQueue.length + ' callbacks fired');
      }
    },

    /**
     * Load a json file and return the contents in a callback
     */
    loadAjaxJSON: function (launcherId, url, callback) {
      var xhr = Launcher.xhr();
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) {
          if (xhr.status == 200 || xhr.status == 304 || xhr.status == 0) {
            try {
              var jsonObject = JSON.parse(xhr.responseText);
              callback(launcherId, jsonObject);
            } catch (error) {
              throw( error );
            }
          } else {
            throw( "Launcher: couldn't load [" + url + "] [" + xhr.status + "]" );
          }
        }
      };
      xhr.open("GET", url, true);
      xhr.send(null);
    },

    /**
     * Returns cross-browser XMLHttpRequest or throws if unable
     */
    xhr: function () {
      try {
        return new XMLHttpRequest();
      } catch (e) {
      }
      try {
        return new ActiveXObject("Msxml3.XMLHTTP");
      } catch (e) {
      }
      try {
        return new ActiveXObject("Msxml2.XMLHTTP.6.0");
      } catch (e) {
      }
      try {
        return new ActiveXObject("Msxml2.XMLHTTP.3.0");
      } catch (e) {
      }
      try {
        return new ActiveXObject("Msxml2.XMLHTTP");
      } catch (e) {
      }
      try {
        return new ActiveXObject("Microsoft.XMLHTTP");
      } catch (e) {
      }

      throw( "Launcher: browser has no XHR support" );
    },

    /**
     * inArray method to see if a string is present in an array
     */
    inArray: function (needle, haystack) {
      for (var key in haystack) {
        if (needle === haystack[key]) {
          return true;
        }
      }
      return false;
    },

    /**
     * Cross-browser getAttribute() method
     */
    getAttr: function (el, attr) {
      var result = (el.getAttribute && el.getAttribute(attr)) || null;
      if (!result) {
        var attrs = el.attributes;
        var length = attrs.length;
        for (var i = 0; i < length; i++) {
          if (attr[i] !== undefined) {
            if (attr[i].nodeName === attr) {
              result = attr[i].nodeValue;
            }
          }
        }
      }
      return result;
    },

    /**
     * Method to see if a value is callable
     */
    isFunction: function (obj) {
      return !!(obj && obj.constructor && obj.call && obj.apply);
    },

    /**
     * Log to console if available
     */
    log: function (logline) {
      if (Launcher.debug && window.console && Launcher.isFunction(console.log)) {
        console.log('Launcher: ' + logline);
      }
    }
  };

  // Make this script execute after domReady
  Launcher.domReady(function () {
    Launcher.init();
  });
}
